/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Plugins
import { registerPlugins } from '@/plugins'
import { registerSW } from 'virtual:pwa-register'
import { useAnalyticsStore, useAppGlobalStore } from '@/store/app'
import { sendEvent, setDefaultProps } from './services/analytics'
import router from '@/router'

// Components
import App from '@/App.vue'

// Composables
import { createApp } from 'vue'

// Styles
import '@/styles/index.css'

const app = createApp(App)

registerPlugins(app)

export const updateSW = registerSW({
  /* onRegistered(r) {
    console.log('ServiceWorker onRegistered')
    // r && r.update()
  }, */
  onNeedRefresh() {
    console.log('ServiceWorker onNeedRefresh')
    const appGlobalStore = useAppGlobalStore()
    // appGlobalStore.setSnackbarText('¡Hay una versión nueva de la aplicación!', true, -1)
    appGlobalStore.setSnackbarText('Actualizando la web...', false, -1)
    setTimeout(() => appGlobalStore.acceptSnackbar(), 3500)
  } //,
  /* onOfflineReady() {
    // const appGlobalStore = useAppGlobalStore()
    // appGlobalStore.setSnackbarText('¡La aplicación está preparada para usarse offline!')
  } */
})

// registerSW({ immediate: true })

setDefaultProps({})

let sessionDuration = Date.now()

const initializeSessionStartTime = () => {
  console.log('Initialize Session')
  console.log('AppState Transition to: started')
  sendEvent('session_started')
  sessionDuration = Date.now()
}

const calculateSessionDuration = () => Date.now() - sessionDuration

initializeSessionStartTime()

window.addEventListener('beforeunload', () => {
  console.log('beforeunload')
  console.log('AppState Transition to: closed')
  const analyticsStore = useAnalyticsStore()
  analyticsStore.resetQueryParams()
  sendEvent('session_closed', { duration: calculateSessionDuration() })
})

document.addEventListener('visibilitychange', () => {
  console.log('visibilitychange: ' + document.visibilityState)
  if (document.visibilityState === 'hidden') {
    console.log('AppState Transition to: paused')
    sendEvent('session_paused', { duration: calculateSessionDuration() })
  } else if (document.visibilityState === 'visible') {
    console.log('AppState Transition to: resumed')
    sendEvent('session_resumed', { duration: calculateSessionDuration() })
  }
})

app.mount('#app')
